module.exports = __webpack_public_path__ + "img/28_61.bca77c1c.png";